<template>

  <div class="containera">
    <!-- Header -->
    <Header></Header>
    <!--在线留言-->
    <div class="container">
      <div class="message">
        <h2>在线留言</h2>
        <div class="common-border"></div>
        <div class="message-container">
          <div class="need"><span class="must-tag">*</span><span>描述你的需求</span><textarea rows="4" cols="20" @input="need"></textarea></div>
          <div class="name"><span class="must-tag">*</span><span>姓名&nbsp;&nbsp;</span><input type="text" @input="name"><span class="must-tag">*</span><span>邮箱&nbsp;&nbsp;</span><input type="text" @input="email"></div>
          <div class="phonenumber"><span class="must-tag">*</span><span>手机&nbsp;&nbsp;</span><input type="text" @input="phone"><span class="must-tag">*</span><span>省份&nbsp;&nbsp;</span><input type="text" @input="province"></div>
          <div class="position"><span class="must-tag">*</span><span>单位&nbsp;&nbsp;</span><input type="text" @input="company"><span>&nbsp;&nbsp;职务&nbsp;&nbsp;</span><input type="text" @input="position"></div>
          <div class="partment"><span>&nbsp;&nbsp;部门&nbsp;&nbsp;</span><input type="text" @input="partment"><span>&nbsp;&nbsp;行业&nbsp;&nbsp;</span><input type="text" @input="job"></div>
<!--          <div class="code"><span><span class="must-tag">*</span>验证码&nbsp;&nbsp;</span><input type="text"></div>-->
          <div class="select"><span>是否需要销售代表与您联系</span> <span><input type="checkbox" @input="islink">是</span><span><input type="checkbox" @input="unlink">否</span></div>
          <div class="allow"><input type="checkbox" @input="isemail"><span>愿意通过电子邮件接收来自辰图大数据的咨询和信息</span></div>
          <div class="alert"><span>您点击“提交”，表明您已理解并同意接受<a href="javascript:;" @click="policy">辰图隐私政策</a>和<a href="javascript:;" @click="agreement">辰图网站用户协议</a>。</span></div>
          <div class="commit" @click="commit">提交</div>
        </div>
      </div>
    </div>
    <!-- Footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import axios from 'axios'
var CONFIG = require('@/common/config.js')
var base_url = CONFIG.API_URL.BASE_URL

export default {
  data () {
    return {
      base_url: base_url, // base_url
      aboutInfo: [], // 关于我们信息列表
      productImg: '../../static/images/about/Image 20.png',
      needs: '',
      names: '',
      emails: '',
      phones: '',
      provinces: '',
      companys: '',
      positions: '',
      partments: '',
      jobs: '',
      islinks: '',
      unlinks: '',
      isemails: '',
      data: []
    }
  },
  created: function () {

  },
  methods: {

    need: function ($event) {
      this.needs = $event.target.value
    },
    name: function ($event) {
      this.names = $event.target.value
    },
    email: function ($event) {
      this.emails = $event.target.value
    },
    phone: function ($event) {
      this.phones = $event.target.value
    },
    province: function ($event) {
      this.provinces = $event.target.value
    },
    company: function ($event) {
      this.companys = $event.target.value
    },
    position: function ($event) {
      this.positions = $event.target.value
    },
    partment: function ($event) {
      this.partments = $event.target.value
    },
    job: function ($event) {
      this.jobs = $event.target.value
    },
    islink: function ($event) {
      if (this.islinks == 'on') {
        this.islinks = ''
      } else {
        this.islinks = $event.target.value
      }
    },
    unlink: function ($event) {
      if (this.unlinks == 'on') {
        this.unlinks = ''
      } else {
        this.unlinks = $event.target.value
      }
    },
    isemail: function ($event) {
      if (this.isemails == 'on') {
        this.isemails = ''
      } else {
        this.isemails = $event.target.value
      }
    },
  // 获取配置信息
  commit: function () {
    var that = this
    if(this.needs == ''){
      alert('输入信息有误，请检查后重新提交！！！')
      return false
    }
    if(this.names == ''){
      alert('输入信息有误，请检查后重新提交！！！')
      return false
    }
    if(this.emails == ''){
      alert('输入信息有误，请检查后重新提交！！！')
      return false
    }
    if(this.phones == ''){
      alert('输入信息有误，请检查后重新提交！！！')
      return false
    }
    if(this.provinces == ''){
      alert('输入信息有误，请检查后重新提交！！！')
      return false
    }
    // if(this.positions == ''){
    //   alert('输入信息有误，请检查后重新提交！！！')
    //   return false
    // }
    // if(this.partments == ''){
    //   alert('输入信息有误，请检查后重新提交！！！')
    //   return false
    // }
    // if(this.jobs == ''){
    //   alert('输入信息有误，请检查后重新提交！！！')
    //   return false
    // }
    if(that.unlinks == 'on' && that.islinks == 'on' || that.unlinks == '' && that.islinks == ''){
      alert('输入信息有误，请检查后重新提交！！！')
      return false
    }else {
      if(that.islinks == 'on'){
        that.islinks =1
      }else {
        that.islinks =2
      }
      // if(that.unlinks == 'on'){
      //   that.unlinks =1
      // }else {
      //   that.unlinks =2
      // }
      if(that.isemails == 'on'){
        that.isemails =1
      }else {
        that.isemails =2
      }
      var data = {
        need: that.needs,
        name: that.names,
        email: that.emails,
        phone: that.phones,
        province: that.provinces,
        company: that.companys,
        position: that.positions,
        partment: that.partments,
        job: that.jobs,
        isLink: that.islinks,
        // unlink: that.unlinks,
        isEmail: that.isemails
      }
      axios.post(base_url + 'front/addMessage', data).then(function (res) {
        if (res.data.code == 0) {
          alert('提交成功！')
          window.location.reload()
        }
      }).catch(function (err) {
        // console.log(err);
      })
    }
  },
    //跳转政策界面
    policy: function () {
      this.$router.push({ path: '/policy' });
  },
    //跳转协议界面
    agreement: function () {
      this.$router.push({ path: '/agreement' });
    }

  }
}
</script>

<style scoped>
  @import url("message.css");
</style>



// WEBPACK FOOTER //
// src/views/message/message.vue